module.exports = __webpack_public_path__ + "img/ios3-min.jpg";